<template>
    <div>         
        <!-- CONTENIDO PRINCIPAL -->
         <div class="container contenido_principal" style="margin-bottom:5rem">
            <boton-atras :nombre_ruta="'informacion'"></boton-atras>
            <div>
                <div>
                    <h6 class="subtitulo mb-2">FOPROVEP.- Ajustadores autorizados</h6>
                    <div class="lineaNegra"></div><div class="mt-1 mb-2 lineaNegra2"></div>
                </div>
                <div class="cards">
                    <div class="cards__fila row">
                        <a @click="asignarNombreImagen('Región I Centro', 'region_centro.svg')" type="button" class="cards__columna col-xs-12 col-sm-6 col-md-3" data-toggle="modal" data-target="#exampleModalCenter">
                            <div class="cards__contenido text-center h-20">
                                <img class="cards__contenido--imagen card-img-top" src="@/assets/imagenes/seccionFoprovep/region_centro.svg"  alt="...">
                                <h6 class="cards__contenido--titulo">Región I Centro</h6> <!----style="font-weight: bold;"----->                                                
                            </div>
                        </a>
                        <!-- ------------------------- -->
                        <a @click="asignarNombreImagen('Región II Altos', 'region_altos.svg')" type="button" class="cards__columna col-xs-12 col-sm-6 col-md-3" data-toggle="modal" data-target="#exampleModalCenter">
                            <div class="cards__contenido text-center h-20">
                                <img class="cards__contenido--imagen card-img-top" src="@/assets/imagenes/seccionFoprovep/region_altos.svg"  alt="...">
                                <h6 class="cards__contenido--titulo">Región II Altos</h6> <!----style="font-weight: bold;"----->                                                
                            </div>
                        </a>
                        <!-- ------------------------------------ -->
                        <a @click="asignarNombreImagen('Región III Fronteriza', 'region_fronteriza.svg')" type="button" class="cards__columna col-xs-12 col-sm-6 col-md-3" data-toggle="modal" data-target="#exampleModalCenter">
                            <div class="cards__contenido text-center h-20">
                                <img class="cards__contenido--imagen card-img-top" src="@/assets/imagenes/seccionFoprovep/region_fronteriza.svg"  alt="...">
                                <h6 class="cards__contenido--titulo">Región III Fronteriza</h6> <!----style="font-weight: bold;"----->                                                
                            </div>
                        </a>
                        <!-- --------------------------------------- -->
                        <a @click="asignarNombreImagen('Región IV Frailesca', 'region_frailesca.svg')" type="button" class="cards__columna col-xs-12 col-sm-6 col-md-3" data-toggle="modal" data-target="#exampleModalCenter">
                            <div class="cards__contenido text-center h-20">
                                <img class="cards__contenido--imagen card-img-top" src="@/assets/imagenes/seccionFoprovep/region_frailesca.svg"  alt="...">
                                <h6 class="cards__contenido--titulo">Región IV Frailesca</h6> <!----style="font-weight: bold;"----->                                                
                            </div>
                        </a>                        
                    </div>

                    <div class="cards__fila row">
                        <a @click="asignarNombreImagen('Región V Norte', 'region_norte.svg')" type="button" class="cards__columna col-xs-12 col-sm-6 col-md-3" data-toggle="modal" data-target="#exampleModalCenter">
                            <div class="cards__contenido text-center h-20">
                                <img class="cards__contenido--imagen card-img-top" src="@/assets/imagenes/seccionFoprovep/region_norte.svg"  alt="...">
                                <h6 class="cards__contenido--titulo">Región V Norte</h6> <!----style="font-weight: bold;"----->                                                
                            </div>
                        </a>
                        <!-- ------------------------- -->
                        <a @click="asignarNombreImagen('Región VI Selva', 'region_selva.svg')" type="button" class="cards__columna col-xs-12 col-sm-6 col-md-3" data-toggle="modal" data-target="#exampleModalCenter">
                            <div class="cards__contenido text-center h-20">
                                <img class="cards__contenido--imagen card-img-top" src="@/assets/imagenes/seccionFoprovep/region_selva.svg"  alt="...">
                                <h6 class="cards__contenido--titulo">Región VI Selva</h6> <!----style="font-weight: bold;"----->                                                
                            </div>
                        </a>
                        <!-- ------------------------------------ -->
                        <a @click="asignarNombreImagen('Región VII Sierra', 'region_sierra.svg')" type="button" class="cards__columna col-xs-12 col-sm-6 col-md-3" data-toggle="modal" data-target="#exampleModalCenter">
                            <div class="cards__contenido text-center h-20">
                                <img class="cards__contenido--imagen card-img-top" src="@/assets/imagenes/seccionFoprovep/region_sierra.svg"  alt="...">
                                <h6 class="cards__contenido--titulo">Región VII Sierra</h6> <!----style="font-weight: bold;"----->                                                
                            </div>
                        </a>
                        <!-- --------------------------------------- -->
                        <a @click="asignarNombreImagen('Región VIII Soconusco', 'region_soconusco.svg')" type="button" class="cards__columna col-xs-12 col-sm-6 col-md-3" data-toggle="modal" data-target="#exampleModalCenter">
                            <div class="cards__contenido text-center h-20">
                                <img class="cards__contenido--imagen card-img-top" src="@/assets/imagenes/seccionFoprovep/region_soconusco.svg"  alt="...">
                                <h6 class="cards__contenido--titulo">Región VIII Soconusco</h6> <!----style="font-weight: bold;"----->                                                
                            </div>
                        </a>                        
                    </div>
                    <div class="cards__fila row">
                         <a @click="asignarNombreImagen('Región IX Istmo-Costa', 'itsmo_costa.svg')" type="button" class="cards__columna col-xs-12 col-sm-6 col-md-3" data-toggle="modal" data-target="#exampleModalCenter">
                            <div class="cards__contenido text-center h-20">
                                <img class="cards__contenido--imagen card-img-top" src="@/assets/imagenes/seccionFoprovep/itsmo_costa.svg"  alt="...">
                                <h6 class="cards__contenido--titulo">Región IX Istmo-Costa</h6> <!----style="font-weight: bold;"----->                                                
                            </div>
                        </a>
                    </div>

                    
                    <!-- Modal -->
                    <div v-if="nombre_region && imagen_region"> <!-----Llamar el componente cuando las variables nombre_region e imagen_region esten llenas---------------------->
                        <ajustador-modal :nombre_region=nombre_region :imagen_region=imagen_region :datos_region=datos_region></ajustador-modal>
                    </div>
                </div>           
            </div>
            <section class="informacion_adicional my-5 container">
            <div class="informacion_adicional__nota">
                <h6 class="informacion_adicional__parrafo">*Se hace mención que salvo las roturas de cristales y espejos laterales, 
                <span class="informacion_adicional__parrafo--resaltado">los siniestros deben de ser informados de manera inmediata a la Coordinación Operativa del FOPROVEP,</span> y en cumplimiento a los tres 
                primero párrafos del numeral 21 de nuestro ordenamiento legal vigente, una vez reportado el siniestro, los conductores deberán de esperar 
                a que el ajustador acuda al lugar del siniestro para darles la atención que amerite el caso, solamente tendrán una atención distinta los siniestros 
                que ocurran en las zonas IV, V y VI, ya que esta Coordinación no cuenta con ajustadores fijos en esas demarcaciones, por lo que al momento de reportar el siniestro
                esta Coordinación les dará las instrucciones necesarias sobre el procedimiento que deben seguir, finalmente de no observar lo antes dispuesto, se
                actualizará la causal de exclusión de coberturas que previene el inciso 11), de la regla 19, de nuestro ordenamiento legal vigente, por lo que exhortamos a que hagan 
                del conocimiento de lo anterior a los servidores públicos adscritos a sus Dependencias que cuenten bajo su resguardo con un vehículo asegurado por este Fideicomiso</h6>
            </div>
        </section>
            
         </div>
    </div>
</template>
<script>
import botonAtras from './../../button-atras'
import ajustadorModal from './infoAjustadorModal'
export default {
    components:{
        botonAtras,
        ajustadorModal
    },
    data: function(){
        return{
            // variables
            nombre_region:'',
            imagen_region:'',
            datos_region: {},
            region_centro: {"centro":{
                                "ajustadores":[
                                
                                            {"nombre": "Ernesto de la Cruz Vázquez",
                                            "tel_oficina":"61 2 66 02",
                                            "tel_celular":"961 65 542 84"},

                                            {"nombre": "Jorge Alberto Gómez Mandujano",
                                            "tel_oficina":"",
                                            "tel_celular":"961 19 494 33"}
                                        ],
                                "municipios":
                                    [
                                        {
                                            "nombre_municipio": "Acala",
                                            "clave":  "002"            
                                        },
                                        {
                                            "nombre_municipio": "Berriozabal",
                                            "clave":  "012"            
                                        },
                                        {
                                            "nombre_municipio": "Cintalapa",
                                            "clave":  "017"            
                                        },
                                        {
                                            "nombre_municipio": "Coapilla",
                                            "clave":  "018"            
                                        },
                                        {
                                            "nombre_municipio": "Copainala",
                                            "clave":  "021"            
                                        },
                                        {
                                            "nombre_municipio": "Chiapa de Corzo",
                                            "clave":  "027"            
                                        },
                                        {
                                            "nombre_municipio": "Chiapilla",
                                            "clave":  "028"            
                                        },
                                        {
                                            "nombre_municipio": "Nicolas Ruíz",
                                            "clave":  "058"            
                                        },
                                        {
                                            "nombre_municipio": "Chicoasén",
                                            "clave":  "029"            
                                        },
                                        {
                                            "nombre_municipio": "Ixtapa",
                                            "clave":  "044"            
                                        },
                                        {
                                            "nombre_municipio": "Jiquipilas",
                                            "clave":  "046"            
                                        },
                                        {
                                            "nombre_municipio": "San Lucas",
                                            "clave":  "110"            
                                        },
                                        {
                                            "nombre_municipio": "Ocotepec",
                                            "clave":  "060"            
                                        },
                                        {
                                            "nombre_municipio": "Ocozocoautla de Espinosa",
                                            "clave":  "061"            
                                        },
                                        {
                                            "nombre_municipio": "Osumacinta",
                                            "clave":  "063"            
                                        },
                                        {
                                            "nombre_municipio": "San Fernando",
                                            "clave":  "079"            
                                        },
                                        {
                                            "nombre_municipio": "Soyalo",
                                            "clave":  "085"            
                                        },
                                        {
                                            "nombre_municipio": "Suchiapa",
                                            "clave":  "086"            
                                        },
                                        {
                                            "nombre_municipio": "Tecpatán",
                                            "clave":  "092"            
                                        },
                                        {
                                            "nombre_municipio": "Totolapa",
                                            "clave":  "098"            
                                        },
                                        {
                                            "nombre_municipio": "Tuxtla Gutiérrez",
                                            "clave":  "101"            
                                        },
                                        {
                                            "nombre_municipio": "Venustiano Carranza",
                                            "clave":  "106"            
                                        }

                                    ]
                                        }
                                        },
            region_altos: {"altos":{
                                "ajustadores":[
                                
                                            {"nombre": "Rafael Terrones Ruiz",
                                            "tel_oficina":"967 67 822 23",
                                            "tel_celular":"967 11 106 28"}
                                        ],
                                "municipios":
                                    [
                                        {
                                            "nombre_municipio": "Altamirano",
                                            "clave":  "004"            
                                        },
                                        {
                                            "nombre_municipio": "Amatenango del Valle",
                                            "clave":  "007"            
                                        },
                                        {
                                            "nombre_municipio": "Chalchihuitán",
                                            "clave":  "022"            
                                        },
                                        {
                                            "nombre_municipio": "Chamula",
                                            "clave":  "023"            
                                        },
                                        {
                                            "nombre_municipio": "Chanal",
                                            "clave":  "024"            
                                        },
                                        {
                                            "nombre_municipio": "Chenalhó",
                                            "clave":  "026"            
                                        },
                                        {
                                            "nombre_municipio": "Huixtán",
                                            "clave":  "038"            
                                        },
                                        {
                                            "nombre_municipio": "Lárrainzar",
                                            "clave":  "049"            
                                        },
                                        {
                                            "nombre_municipio": "Mitontic",
                                            "clave":  "056"            
                                        },
                                        {
                                            "nombre_municipio": "Oxchuc",
                                            "clave":  "064"            
                                        },
                                        {
                                            "nombre_municipio": "Pantelhó",
                                            "clave":  "066"            
                                        },
                                        {
                                            "nombre_municipio": "Las Rosas",
                                            "clave":  "075"            
                                        },
                                        {
                                            "nombre_municipio": "San Cristóbal de las Casas",
                                            "clave":  "078"            
                                        },
                                        {
                                            "nombre_municipio": "Tenejapa",
                                            "clave":  "093"            
                                        },
                                        {
                                            "nombre_municipio": "Teopisca",
                                            "clave":  "094"            
                                        },
                                        {
                                            "nombre_municipio": "Zinacantán",
                                            "clave":  "111"            
                                        },
                                        {
                                            "nombre_municipio": "Aldama",
                                            "clave":  "113"            
                                        },
                                        {
                                            "nombre_municipio": "Santiago El Pinar",
                                            "clave": "119"
                                        }

                                    ]
                                            
                                
                                        
                                    }
                                    },
            region_fronteriza:{"fronteriza":{
                            "ajustadores":[
                            
                                        {"nombre": "José Osbi López Aguilar",
                                        "tel_oficina":"963 63 228 30",
                                        "tel_celular":"963 11 674 90"}
                                    ],
                            "municipios":
                                [
                                    {
                                        "nombre_municipio": "Comitán de Dominguez",
                                        "clave":  "019"            
                                    },
                                    {
                                        "nombre_municipio": "Chicomuselo",
                                        "clave":  "030"            
                                    },
                                    {
                                        "nombre_municipio": "Frontera Comalapa",
                                        "clave":  "034"            
                                    },
                                    {
                                        "nombre_municipio": "Independencia, La",
                                        "clave":  "041"            
                                    },
                                    {
                                        "nombre_municipio": "Margaritas, Las",
                                        "clave":  "052"            
                                    },
                                    {
                                        "nombre_municipio": "Trinitaria, La",
                                        "clave":  "099"            
                                    },
                                    {
                                        "nombre_municipio": "Socoltenango",
                                        "clave":  "083"            
                                    },
                                    {
                                        "nombre_municipio": "Tzimol",
                                        "clave":  "104"            
                                    },
                                    {
                                        "nombre_municipio": "Maravilla Tenejapa",
                                        "clave":  "115"            
                                    }

                                ]
                                        
                            
                                    
                                }
                            },
            region_frailesca: {"frailesca":{
                                "ajustadores":[
                                
                                            {"nombre": "Ernesto de la Cruz Vázquez",
                                            "tel_oficina":"61 2 66 02",
                                            "tel_celular":"961 65 542 84"},

                                            {"nombre": "Jorge Alberto Gómez Mandujano",
                                            "tel_oficina":"",
                                            "tel_celular":"961 19 494 33"}
                                        ],
                                "municipios":
                                    [
                                        {
                                            "nombre_municipio": "Ángel Albino Corzo",
                                            "clave":  "008"            
                                        },
                                        {
                                            "nombre_municipio": "Concordia, La",
                                            "clave":  "020"            
                                        },
                                        {
                                            "nombre_municipio": "Villa Corzo",
                                            "clave":  "107"            
                                        },
                                        {
                                            "nombre_municipio": "Villaflores",
                                            "clave":  "108"            
                                        },
                                        {
                                            "nombre_municipio": "Montecristo de Guerrero",
                                            "clave":  "117"            
                                        }
                                    ]
                                            
                                
                                        
                                    }
                                    },
            region_norte: {"norte":{
                                "ajustadores":[
                                
                                            {"nombre": "Ernesto de la Cruz Vázquez",
                                            "tel_oficina":"61 2 66 02",
                                            "tel_celular":"961 65 542 84"},

                                            {"nombre": "Jorge Alberto Gómez Mandujano",
                                            "tel_oficina":"",
                                            "tel_celular":"961 19 494 33"}
                                        ],
                                "municipios":
                                    [
                                        {
                                            "nombre_municipio": "Amatan",
                                            "clave":  "005"            
                                        },
                                        {
                                            "nombre_municipio": "Bochil",
                                            "clave":  "013"            
                                        },
                                        {
                                            "nombre_municipio": "Bosque, El",
                                            "clave":  "014"            
                                        },
                                        {
                                            "nombre_municipio": "Chapultenango",
                                            "clave":  "025"            
                                        },
                                        {
                                            "nombre_municipio": "Francisco León",
                                            "clave":  "033"            
                                        },
                                        {
                                            "nombre_municipio": "Huitiupán",
                                            "clave":  "039"            
                                        },
                                        {
                                            "nombre_municipio": "Ixtahuatán",
                                            "clave":  "042"            
                                        },
                                        {
                                            "nombre_municipio": "Ixtacomitán",
                                            "clave":  "043"            
                                        },
                                        {
                                            "nombre_municipio": "Ixtapangajoya",
                                            "clave":  "045"            
                                        },
                                        {
                                            "nombre_municipio": "Jitotol",
                                            "clave":  "047"            
                                        },
                                        {
                                            "nombre_municipio": "Juárez",
                                            "clave":  "048"            
                                        },
                                        {
                                            "nombre_municipio": "Ostuacán",
                                            "clave":  "062"            
                                        },
                                        {
                                            "nombre_municipio": "Pantepec",
                                            "clave":  "067"            
                                        },
                                        {
                                            "nombre_municipio": "Pichucalco",
                                            "clave":  "068"            
                                        },
                                        {
                                            "nombre_municipio": "Pueblo Nuevo Solistahuacán",
                                            "clave":  "072"            
                                        },
                                        {
                                            "nombre_municipio": "Rayón",
                                            "clave":  "073"            
                                        },
                                        {
                                            "nombre_municipio": "Reforma",
                                            "clave":  "074"            
                                        },
                                        {
                                            "nombre_municipio": "Simojovel",
                                            "clave":  "081"            
                                        },
                                        {
                                            "nombre_municipio": "Solosuchiapa",
                                            "clave":  "084"            
                                        },
                                        {
                                            "nombre_municipio": "Sunuapa",
                                            "clave":  "088"            
                                        },
                                        {
                                            "nombre_municipio": "Tapalapa",
                                            "clave":  "090"            
                                        },
                                        {
                                            "nombre_municipio": "Tapilula",
                                            "clave":  "091"            
                                        },
                                        {
                                            "nombre_municipio": "San Ándres Duraznal",
                                            "clave":  "072"            
                                        }
                                        
                                    ]
                                            
                                
                                        
                                    }
                                },
            region_selva: {"selva":{
                            "ajustadores":[
                            
                                        {"nombre": "Rafael Terrontes Ruiz",
                                        "tel_oficina":"967 67 822 23",
                                        "tel_celular":"967 11 106 28"}
                                    ],
                            "municipios":
                                [
                                    {
                                        "nombre_municipio": "Catazajá",
                                        "clave":  "016"            
                                    },
                                    {
                                        "nombre_municipio": "Chilón",
                                        "clave":  "031"            
                                    },
                                    {
                                        "nombre_municipio": "Libertad, La",
                                        "clave":  "050"            
                                    },
                                    {
                                        "nombre_municipio": "Ocosingo",
                                        "clave":  "059"            
                                    },
                                    {
                                        "nombre_municipio": "Palenque",
                                        "clave":  "065"            
                                    },
                                    {
                                        "nombre_municipio": "Sabanilla",
                                        "clave":  "076"            
                                    },
                                    {
                                        "nombre_municipio": "Salto de Agua",
                                        "clave":  "077"            
                                    },
                                    {
                                        "nombre_municipio": "Sitalá",
                                        "clave":  "082"            
                                    },
                                    {
                                        "nombre_municipio": "Tila",
                                        "clave":  "096"            
                                    },
                                    {
                                        "nombre_municipio": "Tumbalá",
                                        "clave":  "100"            
                                    },
                                    {
                                        "nombre_municipio": "Yajalón",
                                        "clave":  "109"            
                                    },
                                    {
                                        "nombre_municipio": "San Juan Cancuc",
                                        "clave":  "112"            
                                    },
                                    {
                                        "nombre_municipio": "Benemérito de las Américas",
                                        "clave":  "114"            
                                    },
                                    {
                                        "nombre_municipio": "Marqués de Comillas",
                                        "clave":  "116"            
                                    }            
                                ]
                                        
                            
                                    
                                }
                            },
            region_sierra: {"sierra":{
                                "ajustadores":[
                                
                                            {"nombre": "José Fernando Chirino",
                                            "tel_oficina":"01 962 62 6 27 99",
                                            "tel_celular":"962 13 899 66"}
                                        ],
                                "municipios":
                                    [
                                        {
                                            "nombre_municipio": "Amatenango de la Frontera",
                                            "clave":  "006"            
                                        },
                                        {
                                            "nombre_municipio": "Bejucal de Ocampo",
                                            "clave":  "010"            
                                        },
                                        {
                                            "nombre_municipio": "Bella Vista",
                                            "clave":  "011"            
                                        },
                                        {
                                            "nombre_municipio": "Grandeza, La",
                                            "clave":  "036"            
                                        },
                                        {
                                            "nombre_municipio": "Mazapa de Madero",
                                            "clave":  "053"            
                                        },
                                        {
                                            "nombre_municipio": "Motozintla",
                                            "clave":  "057"            
                                        },
                                        {
                                            "nombre_municipio": "Porvenir, El",
                                            "clave":  "070"            
                                        },
                                        {
                                            "nombre_municipio": "Siltepec",
                                            "clave":  "080"            
                                        }       
                                    ]                    
                                        
                                    }
                                },
            region_soconusco: {"soconusco":{
                                "ajustadores":[
                                
                                            {"nombre": "José Fernando Chirino",
                                            "tel_oficina":"01 962 62 6 27 99",
                                            "tel_celular":"962 13 899 66"}
                                        ],
                                "municipios":
                                    [
                                        {
                                            "nombre_municipio": "Acacoyagua",
                                            "clave":  "001"            
                                        },
                                        {
                                            "nombre_municipio": "Acapetahua",
                                            "clave":  "003"            
                                        },
                                        {
                                            "nombre_municipio": "Cacahoatán",
                                            "clave":  "015"            
                                        },
                                        {
                                            "nombre_municipio": "Escuintla",
                                            "clave":  "032"            
                                        },
                                        {
                                            "nombre_municipio": "Frontera Hidalgo",
                                            "clave":  "035"            
                                        },
                                        {
                                            "nombre_municipio": "Huehuetán",
                                            "clave":  "037"            
                                        },
                                        {
                                            "nombre_municipio": "Huixtla",
                                            "clave":  "040"            
                                        },
                                        {
                                            "nombre_municipio": "Mapastepec",
                                            "clave":  "051"            
                                        },
                                        {
                                            "nombre_municipio": "Mazatán",
                                            "clave":  "054"            
                                        },
                                        {
                                            "nombre_municipio": "Metapa",
                                            "clave":  "055"            
                                        },
                                        {
                                            "nombre_municipio": "Villa Comaltitlán",
                                            "clave":  "071"            
                                        },
                                        {
                                            "nombre_municipio": "Suchiate",
                                            "clave":  "087"            
                                        },
                                        {
                                            "nombre_municipio": "Tapachula",
                                            "clave":  "089"            
                                        },
                                        {
                                            "nombre_municipio": "Tuxtla Chico",
                                            "clave":  "102"            
                                        },
                                        {
                                            "nombre_municipio": "Tuzantán",
                                            "clave":  "103"            
                                        },
                                        {
                                            "nombre_municipio": "Unión Juárez",
                                            "clave":  "105"            
                                        }
                                    ]  
                                        
                                    }
                                },
            region_istmo: {"Istmo":{
                                "ajustadores":[
                                
                                            {"nombre": "Francisco Cortéz Hernández",
                                            "tel_oficina":"01 962 62 6 27 99",
                                            "tel_celular":"966 66 564 84"
                                            }
                                        ],
                                "municipios":
                                    [
                                        {
                                            "nombre_municipio": "Arriaga",
                                            "clave":  "009"            
                                        },
                                        {
                                            "nombre_municipio": "Pijijiapan",
                                            "clave":  "069"            
                                        },
                                        {
                                            "nombre_municipio": "Tonala",
                                            "clave":  "097"            
                                        }
                                        
                                    ]
                                        
                                    }
                                }             
                                        
            
            }
            
    },
    methods:{
        asignarNombreImagen(nombre, imagen){
            this.nombre_region = nombre;
            this.imagen_region = imagen;
            if(this.nombre_region=="Región I Centro") {this.datos_region = this.region_centro}; 
            if(this.nombre_region=="Región II Altos") {this.datos_region = this.region_altos};
            if(this.nombre_region=="Región III Fronteriza") {this.datos_region = this.region_fronteriza};
            if(this.nombre_region=="Región IV Frailesca") {this.datos_region = this.region_frailesca};
            if(this.nombre_region=="Región V Norte") {this.datos_region = this.region_norte}; 
            if(this.nombre_region=="Región VI Selva") {this.datos_region = this.region_selva};
            if(this.nombre_region=="Región VII Sierra") {this.datos_region = this.region_sierra};
            if(this.nombre_region=="Región VIII Soconusco") {this.datos_region = this.region_soconusco};
            if(this.nombre_region=="Región IX Istmo-Costa") {this.datos_region = this.region_istmo};           
            console.log(`Nombre de la region: ${this.nombre_region} , imagen de la region ${this.imagen_region}, municipios de esa region: ${this.municipios_region} `);
            
        }
    },
    
}
</script>

<style scoped>

@media only screen and (max-device-width : 900px) {
    .subtitulo{ 
        font-size: 1.4rem !important;
        margin-top: 1.6rem !important;
    }
    .contenido_principal h5{ font-size: 1rem; }
    .parrafo-contenido{ font-size: 1em !important; }
    .cards__columna{
    box-shadow: 1px 10px 20px -10px rgba(0,0,0,0.6);
    border-radius: 15px;
    text-decoration: none;
}
    .cards__contenido--titulo{
        background-color: #621132;
        opacity: 0.7;
        color: white!important;
        padding: 1rem;
        margin-left: 2rem;
        margin-right: 2rem;
        border-radius: 10px;
    }

    .cards__columna:hover .cards__contenido--imagen{filter: grayscale(100%); /*width: 100%;*/}
}

.parrafo-contenido{
    font-size: 1.3em;
    line-height: 1.8em;
}

/********** */
.cards__fila{
    margin-bottom: 1rem;
}
.cards__columna{
    padding-bottom: 0.5rem;
}
.cards__columna:hover{
    box-shadow: 1px 10px 20px -10px rgba(0,0,0,0.6);
    border-radius: 15px;
    text-decoration: none;
    filter: grayscale(0%);
}
.cards__columna:hover .cards__contenido--imagen{filter: grayscale(0%); /*width: 100%;*/}
.cards__contenido--imagen{
    width: 100%;
     filter: grayscale(100%);
}
.cards__contenido--titulo{
    font-weight: bold;
    color: #212529;
}
.cards__contenido--parrafo{
    color: #6c757d;
    font-size: 80%;
    font-weight: 400;
    margin-bottom: 0;
}
.cards__contenido--link{
    filter: grayscale(100%);
    margin-top: 0.5rem;
    text-decoration: underline;
    font-weight: 500;
    font-size: 90%;
}
.cards__columna:hover .cards__contenido--link{
    filter: grayscale(0%);
    color: #621132;
    /* text-decoration:underline; */
    font-size: 18px;
    /* font-weight: 500; */
}
.cards__contenido--icono{padding-right: 0.3rem;}
.cards__contenido--parrafoCursiva{
    color: #6c757d;
    font-size: 80%;
    font-weight: 400;
    margin-bottom: 0;
    font-style: italic;
}

.informacion_adicional__parrafo{
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 20px;
    text-align: justify;
}
.informacion_adicional__parrafo--resaltado{
    color: #560F2C;
    font-weight: 500;
}

</style>